export default "__VITE_ASSET__bjTK5pYl__"